/**
 * Widget Configuration Constants
 * Shared constants used across widget configuration modules
 */

// Date format options
export const DATE_FORMATS = {
  SHORT: 'MMM D',
  LONG: 'MMM YYYY'
};

// Legend position options
export const LEGEND_POSITIONS = ['bottom', 'right', 'top', 'left'];

// Value format options
export const VALUE_FORMATS = ['currency', 'number', 'percentage', 'decimal'];

// Default fallback values
export const DEFAULT_FALLBACK_SIZES = {
  minW: 2,
  minH: 2,
  defaultW: 4,
  defaultH: 4
};

export const DEFAULT_FALLBACK_DATA = { data: [] };

// Common grouping field names used across widgets
export const GROUPING_FIELDS = [
  'grouping',
  'cost_resource_type',
  'service',
  'organisation_name',
  'organization',
  'organisation',
  'project_name',
  'project',
  'resource_type',
  'account',
  'name',
  'label'
];

// Widget categories for organization
export const WIDGET_CATEGORIES = {
  KPI: 'kpi',
  CHART: 'chart',
  TABLE: 'table',
  RESOURCE: 'resource',
  FORECAST: 'forecast',
  LAYOUT: 'layout'
};

